




























































import {
    defineComponent,
    computed,
    ref,
    PropType
} from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { alarm } from "@/store";
import UserSettingsViewModel from "../../../models/UserSettingsViewModel";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        SensorPanelLayout: () =>
            import(/* webpackChunkName: "components" */ "./SensorPanelLayout.vue"),
        EditGasDialog: () =>
            import(/* webpackChunkName: "components" */ "../Dialogs/EditGasDialog.vue"),
    },
    props: {
        value: { type: Object as PropType<AttachedDeviceModel> }
    },
    setup(props, { emit }) {

        const showGasEditThresholdDialog = ref(false);
        const rawGasLevel = computed(() => {
            const alarmStatus = alarm.alarmStatus;
            const vSupplies = alarmStatus && alarmStatus.VSupplies;
            const raw = vSupplies && vSupplies[0] && vSupplies[0].V4;
            return raw != null ? raw : null;
        });

        const gasLevelValue = computed(() => {
            const value = rawGasLevel.value;
            const num = parseFloat(value != null ? value : "");
            return isNaN(num) ? null : num;
        });

        const connected = computed(() => {
            return gasLevelValue.value !== null && gasLevelValue.value > 0.15;
        });

        const paired = computed<boolean>(() =>
            !!props.value?.attachedDeviceId
        );

        const gasStatus = computed(() => {
            return gasLevelValue.value !== null && gasLevelValue.value < 3;
        });

        const gasLevel = computed(() => {
            if (!connected.value) return "—- ppm";
            return `${gasLevelValue.value.toFixed(0)} ppm`;
        });

        const handleOnSaveGasThreshold = (model: UserSettingsViewModel) => {
            emit("OnNewGasThreshold", model);
        };

        return {
            connected,
            paired,
            gasStatus,
            gasLevel,
            showGasEditThresholdDialog,
            handleOnSaveGasThreshold
        };
    }
});
